<template>

  <data-form
    :entity="formModel"
    :fields="fields"
    @change="onChange"
    @submit="onSubmit"
  />

</template>

<script>
import { post } from 'providers/http'

const IP_PATTERN = '/^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/'

export default {
  name: 'controller-wifi-setting',
  props: {
    controller: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      formModel: {
        manualDhcp: false,
        securityType: 1
      }
    }
  },
  computed: {
    fields () {
      let fields = {
        'ssid': {
          rules: [{ required: true }]
        },
        'securityType': {
          type: 'select',
          options: [
            {
              value: 1,
              label: 'secType.none'
            },
            {
              value: 2,
              label: 'secType.WEP'
            },
            {
              value: 3,
              label: 'secType.WPA'
            },
            {
              value: 4,
              label: 'secType.WPA2'
            }
          ],
          rules: [{ required: true }]
        },
        'password': {
          type: 'password',
          rules: [{ required: this.formModel.securityType !== 1 }]
        },
        'serverHost': {
          rules: [{
            type: 'regexp',
            pattern: IP_PATTERN
          }]
        },
        'serverPort': {
          // rules: [{
          //   type: 'regexp',
          //   pattern: IP_PATTERN
          // }]
        },
        'serverShortCode': {
          // rules: [{
          //   type: 'regexp',
          //   pattern: IP_PATTERN
          // }]
        },
        'manualDhcp': {
          type: 'checkbox'
        }
      }

      let dhcpFields

      if (this.formModel.manualDhcp) {
        dhcpFields = {
          'controllerIp': {
            rules: [{
              type: 'regexp',
              pattern: IP_PATTERN
            }]
          },
          'gatewayIp': {
            rules: [{
              type: 'regexp',
              pattern: IP_PATTERN
            }]
          },
          'subnetMask': {
            rules: [{
              type: 'regexp',
              pattern: IP_PATTERN
            }]
          }
        }
      }

      return {...fields, ...dhcpFields}
    }
  },
  methods: {
    onChange (formModel) {
      this.formModel = formModel
    },
    async onSubmit (formModel) {
      const { id } = this.controller

      try {
        await post(`api/v1/controllers/set-wifi/${id}`, formModel)
      }
      catch (err) {
        console.error(err)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// ControllerWifiSetting.vue?0b95a336